exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-54fc4fd6]{border:1px solid #ececec;text-align:center;padding:.16rem .1rem}a[data-v-54fc4fd6]{word-break:break-all;cursor:pointer}b[data-v-54fc4fd6]{font-weight:700;color:#151515}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54fc4fd6","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/landingPage/ecardHWPolicy.vue
// module id = 656
// module chunks = 22